/**
 * Implementation of Settings Component accessible at "/dashboard/settings"
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactNode } from "react";
import { Outlet } from "react-router";
import { Link } from "react-router-dom";
import ButtonSettings from "./ButtonSettings";
import GeneralSettings from "./GeneralSettings";

export default function Settings() {
  const settingsRoutes: Record<string, ReactNode> = {
    "/general": <GeneralSettings />,
    "/button": <ButtonSettings />,
  };

  const tabs = [
    {
      label: "General",
      to: "/general",
    },
    {
      label: "Button",
      to: "/button",
    },
    {
      label: "Widgets",
      to: "/widgets",
    },
  ];

  return (
    <div>
      {/* <div className="flex bg-white px-4 pb-2 shadow fixed w-full">
        {tabs.map((tab) => (
          <Link to={`/dashboard/settings${tab.to}`}>
            <div
              className={`px-6 py-1 list-none text-md mr-1 rounded-lg transition-all font-semibold ${
                window.location.pathname.startsWith(
                  `/dashboard/settings${tab.to}`
                )
                  ? "text-white bg-accent"
                  : "text-primary bg-transparent hover:bg-accent hover:bg-opacity-10"
              }`}
            >
              {tab.label}
            </div>
          </Link>
        ))}
      </div> */}
      
      <div >
        <Outlet />
      </div>
    </div>
  );
}
